
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.497 15.939L3.67 14.768 0 15.939c0 4.392 1.787 8.5 4.671 11.384l4.466.064.833-5.362c-1.527-1.527-2.473-3.76-2.473-6.086z","fill":"#54E360"}}),_c('path',{attrs:{"d":"M26.13 23.247l-4.113-1.223a8.555 8.555 0 01-6.023 2.473l-2.46 4.92 2.46 2.577c4.392 0 8.437-1.787 11.322-4.672l-1.186-4.075z","fill":"#FDBF00"}}),_c('path',{attrs:{"d":"M28.838 6.437s0-.02-.019-.02c-.468-.618-.956-1.199-1.5-1.723l-3.18.43-2.142 4.874c1.593 1.537 2.493 3.673 2.493 5.941l5.115 2.265 2.381-2.265c0-4.047-1.777-8.131-3.148-9.502z","fill":"#E61E14"}}),_c('path',{attrs:{"d":"M15.993.007A16.029 16.029 0 004.671 4.68s.288 4.075.015 4.348c-.274.273 5.284.95 5.284.95a8.555 8.555 0 016.023-2.473l2.616-3.201L15.993.007z","fill":"#3AAAFF"}}),_c('path',{attrs:{"d":"M9.97 9.979L4.67 4.68A15.881 15.881 0 000 15.94h7.497c0-2.326.946-4.434 2.473-5.961z","fill":"#00CC71"}}),_c('path',{attrs:{"d":"M24.49 15.939c0 2.325-.946 4.558-2.473 6.086l5.298 5.298c2.885-2.884 4.672-6.992 4.672-11.384H24.49z","fill":"#FD4E26"}}),_c('path',{attrs:{"d":"M9.97 22.024l-5.299 5.298a16.028 16.028 0 0011.322 4.672v-7.497a8.555 8.555 0 01-6.023-2.473z","fill":"#FFD400"}}),_c('path',{attrs:{"d":"M27.32 4.693l-5.323 5.304c-.394-.431-.825-.768-1.293-1.087l-.02-.019c-1.386-.918-3.042-1.387-4.69-1.387V.007c4.31 0 8.364 1.687 11.326 4.686z","fill":"#0095FF"}})])
          )
        }
      }
    